import { apiService, ApiResponse } from './api';

export interface AttendanceImportResult {
    successCount: number;
    skipCount: number;
    failedImports: Array<{
        nicPassport: string;
        fullName: string;
        date: string;
    }>;
}

export const uploadAttendanceFile = async (file: File): Promise<AttendanceImportResult> => {
    const formData = new FormData();
    formData.append('file', file);

    const res: ApiResponse<AttendanceImportResult> = await apiService.post('/api/attendance/import', formData);
    if (!res.success || !res.data) {
        throw new Error(res.message || 'Failed to upload attendance file');
    }
    return res.data;
};

export interface AttendanceRecord {
  serialNo: string;
  name: string;
  timeIn: string;
  date?: string;
}

export interface AttendanceSummary {
  marked: number;
  enrolled: number;
  records: AttendanceRecord[];
}

export interface ChartData {
  type?: 'heatmap' | 'bar' | 'doughnut';
  labels: string[];
  datasets: Array<{
    label?: string;
    data: number[];
    backgroundColor: string | string[];
    borderColor: string | string[];
    borderWidth: number;
  }>;
  userAttendanceData?: { [key: string]: number };
  fullNames?: string[];
}

export const getDailyAttendance = async (date: string): Promise<AttendanceSummary> => {
  console.log('Fetching daily attendance for date:', date);
  const res: ApiResponse<AttendanceSummary> = await apiService.get(`/api/attendance/daily?date=${date}`);
  console.log('Daily attendance response:', res);
  if (!res.success || !res.data) {
    throw new Error(res.message || 'Failed to fetch daily attendance');
  }
  return res.data;
};

export const getWeeklyAttendance = async (start: string, end: string): Promise<AttendanceSummary> => {
  console.log('Fetching weekly attendance:', { start, end });
  const res: ApiResponse<AttendanceSummary> = await apiService.get(`/api/attendance/weekly?start=${start}&end=${end}`);
  console.log('Weekly attendance response:', res);
  if (!res.success || !res.data) {
    throw new Error(res.message || 'Failed to fetch weekly attendance');
  }
  return res.data;
};

export const getMonthlyAttendance = async (month: string): Promise<AttendanceSummary> => {
  console.log('Fetching monthly attendance for month:', month);
  const res: ApiResponse<AttendanceSummary> = await apiService.get(`/api/attendance/monthly?month=${month}`);
  console.log('Monthly attendance response:', res);
  if (!res.success || !res.data) {
    throw new Error(res.message || 'Failed to fetch monthly attendance');
  }
  return res.data;
}; 